export default {
  namespaced: true,
  state: { breadcrumbs: [] },
  mutations: {
    SET_BREADCRUMB: (state, breadcrumbs) => {
      state.breadcrumbs = breadcrumbs;
    },
    REPLACE_BREADCRUMB: (state, payload) => {
      const index = state.breadcrumbs.findIndex(breadcrumb => breadcrumb.text === payload.find);

      if (index) {
        state.breadcrumbs.splice(index, 1, payload.replace);
      }
    },
  },
  actions: {
    SETBREADCRUMBS: (store, breadcrumb) => {
      store.commit('SET_BREADCRUMB', breadcrumb);
    },
    REPLACEBREADCRUMBS: (store, payload) => {
      store.commit('REPLACE_BREADCRUMB', payload);
    },
  },
  getters: { getBreadcrumbs: state => state.breadcrumbs },
};
